<template>
  <div class="test">
  <nav class="navbar is-link">
    <div class="navbar-brand">
      <div class="navbar-burger burger"
           @click="toggleBurger"
           v-bind:class="{ 'is-active': isBurgerOn }"
           data-target="navbarExampleTransparentExample">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div id="navbarExampleTransparentExample" class="navbar-menu"
         v-bind:class="{ 'is-active': isBurgerOn }">
      <div class="navbar-start">
        <b-navbar-item tag="router-link" :to="{ path: '/tableau-de-bord' }">
          <span>Tableau de bord</span>
        </b-navbar-item>
        <div class="navbar-item has-dropdown"
        v-bind:class="{ 'is-active': subMenu.catalogue, 'is-hoverable' : !isTouch }"
        >
          <a class="navbar-link" @click="toggleSubMenu('catalogue')">
            Mon catalogue
          </a>
          <div class="navbar-dropdown">
            <router-link class="navbar-item" v-on:click.native="clearMenu()"
              v-bind:to="'/vente-faces-LC'">
              Vente faces LC
            </router-link>
            <router-link class="navbar-item" v-on:click.native="clearMenu()"
              v-bind:to="'/vente-reseaux-temporaires'">
              Vente réseaux temporaires
            </router-link>
            <router-link class="navbar-item" v-on:click.native="clearMenu()"
              v-bind:to="'/vente-reseaux-LC'">
              Vente réseaux LC
            </router-link>
            <router-link class="navbar-item" v-on:click.native="clearMenu()"
              v-bind:to="'/vente-ecrans-numeriques'">
              Vente écrans numériques
            </router-link>
            <router-link class="navbar-item" v-on:click.native="clearMenu()"
              v-bind:to="'/vente-reseaux-numeriques'">
              Vente réseaux numériques
            </router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown"
        v-bind:class="{ 'is-active': subMenu.client, 'is-hoverable' : !isTouch }">
          <a class="navbar-link" @click="toggleSubMenu('client')">
            Mes clients / prospects
          </a>
          <div class="navbar-dropdown">
            <router-link class="navbar-item" v-on:click.native="clearMenu()"
              v-bind:to="'/client-prospect'">
              Recherche
            </router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown"
        v-bind:class="{ 'is-active': subMenu.historique, 'is-hoverable' : !isTouch }">
          <a class="navbar-link" @click="toggleSubMenu('historique')">
            Mon historique
          </a>
          <div class="navbar-dropdown">
            <router-link class="navbar-item" v-on:click.native="clearMenu()"
              v-bind:to="'/mes-opportunites'">
              Mes opportunités
            </router-link>
            <router-link class="navbar-item" v-on:click.native="clearMenu()"
              v-bind:to="'/mes-commandes'">
              Mes propositions / commandes
            </router-link>
          </div>
        </div>
      </div>
      <div class="navbar-end">
        <router-link class="navbar-item mr-130" v-on:click.native="clearMenu()"
          v-if="isSupport" v-bind:to="'/parametrage'">
          <button class="button is-link">
            <b-icon
              icon="cogs"
              size="is-medium"
              style="cursor:pointer;">
              <a>parametre</a>
            </b-icon>
          </button>
        </router-link>
        <router-link class="navbar-item" v-on:click.native="clearMenu()" :to="'/panier'">
          <button class="button is-link">
              <b-icon
                icon="cart-outline"
                size="is-medium"
                style="cursor:pointer;">
                <a>Panier</a>
              </b-icon>
            <p>&#xA0;&#xA0;Panier
              ({{produits.panneauxLc.length +
              produits.reseauxTempo.length +
              produits.reseauxLc.length +
              produits.panneauxNumeriques.length +
              produits.reseauxNumeriques.length + produits.reseauxPersonnalise.length}})</p>
          </button>
        </router-link>
        <div class="navbar-item">
          <button class="button is-link" @click="logOut">
            <b-icon
              icon="power"
              size="is-medium"
              style="cursor:pointer;">
              <a >LogOut</a>
            </b-icon>
          </button>
        </div>
      </div>
    </div>
  </nav>
  </div>
</template>

<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import { createNamespacedHelpers } from 'vuex';

const panier = createNamespacedHelpers('panier');
const user = createNamespacedHelpers('user');

const bowser = require('bowser');

export default {
  name: 'app-header',
  data() {
    return {
      msg: '',
      isBurgerOn: false,
      subMenu: this.getDefaultMenuValues(),
      isTouch: false,
    };
  },
  methods: {
    ...user.mapActions({
      actionLogOut: 'logOut',
    }),
    async logOut() {
      await this.actionLogOut();
      this.$router.push('/connexion');
    },
    toggleBurger() {
      this.isBurgerOn = !this.isBurgerOn;
      return true;
    },
    getDefaultMenuValues() {
      return {
        catalogue: false,
        client: false,
        historique: false,
      };
    },
    toggleSubMenu(id) {
      if (!this.isTouch) {
        return true;
      }
      const backup = this.subMenu[id];
      this.subMenu = this.getDefaultMenuValues();
      this.subMenu[id] = !backup;
      return true;
    },
    clearMenu() {
      this.subMenu = this.getDefaultMenuValues();
      this.isBurgerOn = false;
    },
  },
  computed: {
    ...panier.mapGetters(['produits']),
    ...user.mapGetters({
      isSupport: 'isSupport',
      getCleApiGoogle: 'getCleApiGoogle',
    }),
  },
  mounted() {
    if (bowser.ios || bowser.android) {
      this.isTouch = true;
    }
  },
  created() {
    Vue.use(VueGoogleMaps, {
      load: {
        key: this.getCleApiGoogle,
        libraries: 'places',
      },
    });
  },
  updated() {
    Vue.use(VueGoogleMaps, {
      load: {
        key: this.getCleApiGoogle,
        libraries: 'places',
      },
    });
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue